'use client';

import { createContext, useContext } from 'react';
import type { GlobalContent, NavContent, FooterContent } from '@/lib/content-schema';

interface LayoutContent {
  global: GlobalContent;
  nav: NavContent;
  footer: FooterContent;
}

const ContentContext = createContext<LayoutContent | null>(null);

export function ContentProvider({
  value,
  children,
}: {
  value: LayoutContent;
  children: React.ReactNode;
}) {
  return (
    <ContentContext.Provider value={value}>{children}</ContentContext.Provider>
  );
}

export function useLayoutContent(): LayoutContent {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error('useLayoutContent must be inside ContentProvider');
  return ctx;
}
